module.exports = __webpack_public_path__ + "img/logo.20e162f3.svg";